import { render, staticRenderFns } from "./OrderNowButton.vue?vue&type=template&id=6f7187e4&"
import script from "./OrderNowButton.vue?vue&type=script&lang=js&"
export * from "./OrderNowButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports